<template>
    <navbar position="top" class="white" color="dark" scrolling>
        <mdb-navbar-brand :href="`https://www.comcolors.com/${currentLocale == 'fr' ? '' : currentLocale}`" target="_blank"><img class="comcolors-logo" src="https://www.comcolors.com/public/images/comcolors-logo.png" alt="ComColors Logo" /></mdb-navbar-brand>
        <navbar-collapse>
            <navbar-nav right>
              <li class="nav-item ripple-parent" v-if="isLoggedIn"><localized-link :to="instructionsRoute" class="nav-link navbar-link"><i class="fa fa-th-list" aria-hidden="true"></i> {{$t('the_questionnaire')}}</localized-link></li>
                <dropdown tag="li" class="nav-item" v-if="isLoggedIn">
                    <dropdown-toggle tag="a" navLink color="white" slot="toggle" waves-fixed>
                        <md-avatar class="md-avatar-icon md-small md-primary">
                            <img v-if="userDetails.profileImage !=''" :src="getImgUrl(userDetails.profileImage)" alt="Avatar">
                            <md-ripple v-else>{{ formatName | uppercase }}</md-ripple>
                        </md-avatar>
                        {{ userDetails.firstName | capitalize }} {{ userDetails.lastName | capitalize }}
                    </dropdown-toggle>
                    <dropdown-menu>
                        <dropdown-item>
                            <localized-link to="account">{{$t('account_settings')}}</localized-link>
                        </dropdown-item>
                        <dropdown-item>
                            <localized-link to="change-pwd">{{$t('change_password')}}</localized-link>
                        </dropdown-item>
                    </dropdown-menu>
                </dropdown>
                <LanguageSwitcher />
                <localized-link to="" class="btn-rounded btn btn-info btn-sm ripple-parent" v-if="!isLoggedIn && isActive('Register') || isActive('ForgotPassword')">{{$t('signin')}} <i class="fa fa-sign-in ml-2"></i></localized-link>
                <localized-link to="register" class="btn-rounded btn btn-info btn-sm ripple-parent" v-if="!isLoggedIn && isActive('Authentication') || isActive('ForgotPassword')">{{$t('signup')}}</localized-link>
                <btn color="info" size="sm" class="btn-rounded" v-if="isLoggedIn" @click.native="logout">{{$t('signout')}} <i class="fa fa-sign-out ml-2"></i></btn>
            </navbar-nav>
        </navbar-collapse>
    </navbar>
</template>

<script>
import { Navbar, NavbarItem, NavbarNav, NavbarCollapse, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Btn, waves, mdbNavbarBrand } from 'mdbvue'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import LocalizedLink from '@/components/Menu'
import { mapGetters, mapActions } from 'vuex'
import {getLoggedUser, isTalentApp, isVenteApp} from '../services/User.service'

export default {
    name: 'Header',
    data() {
        return {
            userDetails: {
                firstName: '',
                lastName: '',
                profileImage: ''
            },
            userLocale: '',
            instructionsRoute: 'questionnaire-instructions'
        };
    },
    computed: {
        ...mapGetters(['currentUser','isLoggedIn']),
        formatName(){
            return `${this.userDetails.firstName.charAt(0)}${this.userDetails.lastName.charAt(0)}`;
        },
        currentLocale() {
            return this.$route.params.locale
        }
    },
    watch: {
        '$route': ['getUserData','getCurrentRoute']
    },
    methods: {
        ...mapActions(['setUserDetails']),
        logout() {
            this.$store.dispatch('logout');
            this.$router.push({name:'Authentication'});
            this.userDetails.firstName = ''
            this.userDetails.lastName = ''
        },
        getImgUrl(pic) {
            return 'https://gestion.comcolors.com/img/avatars/'+pic
        },
        getUserData (){
            if(localStorage.getItem('userId')) {
                const userId = localStorage.getItem('userId');
                this.instructionsRoute = isTalentApp() ? 'talent-instructions' : 'questionnaire-instructions'
                this.instructionsRoute = isVenteApp() ? 'questionnaire' : this.instructionsRoute
                getLoggedUser(userId).then(response => {
                    this.setUserDetails(response.data.user_info);
                    const user = response.data.user_info
                    this.userDetails.firstName = user.prenom
                    this.userDetails.lastName = user.nom,
                    this.userDetails.profileImage = user.fichier
                    console.log('UserData Header: ', user)
                }).catch(error => {
                    console.log(error.data.user_info);
                })
            }
        },
        isActive(route) {
            if (this.$router.currentRoute.name == route) {
                return true;
            }
            return false;
        },
        getCurrentRoute(){
            return this.$router.currentRoute
        }
    },
    components: {
        Navbar,
        NavbarItem,
        NavbarNav,
        NavbarCollapse,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        DropdownToggle,
        Btn,
        waves,
        mdbNavbarBrand,
        LanguageSwitcher,
        LocalizedLink
    },
    mounted(){
        this.getUserData();
    }
};
</script>

<style scoped>
.comcolors-logo {
width: 190px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue